// material-ui
import { useTheme } from '@mui/material/styles';
import logoIcon from 'assets/images/icons/vaseelah-icon-new.svg';
import greyIcon from 'assets/images/icons/vaseelah-icon-greyscale.png';
import PropTypes from 'prop-types';

// ==============================|| LOGO SVG ||============================== //

const VaseelahIcon = ({ width, white, loader, faded }) => {
  const theme = useTheme();
  // const size = loader ? 80 : width ? width : 40;
  const size = width ? width : loader ? 80 : 40;

  return faded ? (
    <img src={greyIcon} alt="vaseelah-icon" width={size} className={`${loader ? 'animate-[spin_2s_linear_infinite]' : ''}`} />
  ) : (
    <img
      src={white ? 'assets/images/icons/vaseelah-icon-new.svg' : logoIcon}
      alt="vaseelah-icon"
      width={size}
      className={`${loader ? 'animate-[spin_2s_linear_infinite]' : 'animate-[spin_30s_linear_infinite]'}`}
    />
  );
};

export default VaseelahIcon;

VaseelahIcon.proptypes = {
  width: PropTypes.number,
  white: PropTypes.bool,
  loader: PropTypes.bool,
  faded: PropTypes.bool
};
